/**
 * @fileoverview Servizio per l'albo d'oro (hallOfFame).
 */
import { collection, getDocs, addDoc, query, where, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { COLLECTIONS, HALL_OF_FAME_FIELDS } from '../domain/dataModel';

/**
 * Recupera tutti i documenti hall of fame del gruppo.
 * @param {string} groupId
 * @returns {Promise<Array<{ id: string, ...Object }>>}
 */
export async function getHallOfFame(groupId) {
  try {
    if (!groupId) return [];
    const q = query(
      collection(db, COLLECTIONS.HALL_OF_FAME),
      where(HALL_OF_FAME_FIELDS.GROUP_ID, '==', groupId)
    );
    const snap = await getDocs(q);
    return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  } catch (err) {
    throw new Error(err?.message || 'Errore nel caricamento dell\'albo d\'oro.');
  }
}

/**
 * Salva un documento hall of fame con le classifiche finali del periodo.
 * @param {string} groupId
 * @param {string} periodId
 * @param {Array<Object>} rankings - Array di { position, memberId, finalRating, matchesPlayed, matchesWon, winRate, gamesWon }
 * @returns {Promise<{ hallOfFameId: string }>}
 */
export async function saveHallOfFame(groupId, periodId, rankings) {
  try {
    if (!groupId || !periodId) throw new Error('Gruppo o periodo mancante.');
    const ref = await addDoc(collection(db, COLLECTIONS.HALL_OF_FAME), {
      [HALL_OF_FAME_FIELDS.GROUP_ID]: groupId,
      [HALL_OF_FAME_FIELDS.PERIOD_ID]: periodId,
      [HALL_OF_FAME_FIELDS.RANKINGS]: rankings || [],
      [HALL_OF_FAME_FIELDS.CREATED_AT]: serverTimestamp(),
    });
    return { hallOfFameId: ref.id };
  } catch (err) {
    throw new Error(err?.message || 'Errore nel salvataggio dell\'albo d\'oro.');
  }
}
